import { render, staticRenderFns } from "./OfficialHosted.vue?vue&type=template&id=47c4e3b2&scoped=true&"
import script from "./OfficialHosted.vue?vue&type=script&lang=js&"
export * from "./OfficialHosted.vue?vue&type=script&lang=js&"
import style0 from "./OfficialHosted.vue?vue&type=style&index=0&id=47c4e3b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4e3b2",
  null
  
)

export default component.exports